import { css } from '@emotion/css';

export const actionItemMenu = css`

    :hover {
        transform: scale(.9);
    }
`;